// @ts-nocheck
import Messenger from "../common/Messenger"

const CustomerMessenger = (props) => {
    return (
        <Messenger {...props} />
    )
}

export default CustomerMessenger